export const colors = {
    black: '#000',
    black80: 'rgba(0, 0, 0, .8)',
    black50: 'rgba(0, 0, 0, .5)',
    black35: 'rgba(0, 0, 0, .35)',
    black25: 'rgba(0, 0, 0, .25)',
    black20: 'rgba(0, 0, 0, .20)',
    darkGrey: '#2B2C2D',
    white: '#fff',
    white20: 'rgba(255, 255, 255, .2)',
    white30: 'rgba(255, 255, 255, .3)',
    white50: 'rgba(255, 255, 255, .5)',
    white80: 'rgba(255, 255, 255, .8)',
    white90: 'rgba(255, 255, 255, .9)',
    redButton: '#E6001E',
    blackTextButton: '#141414',
    generalWOLilac: '#8F00CC',
    aussieYellow: '#FBF200',

    designSystem: {
        greyMystic: '#d6d6d6',
        lightGrey: '#eee',
        darkGrey: '#333',
        opusGreen: '#009563',
    },

    thewest: {
        // Shades of grey
        greyGorilla: '#2b2c2d',
        greyRhino: '#3D3D3D',
        greyElephant: '#535556',
        greyKoala: '#74787a',
        greyHippo: '#888d90',
        greyQuokka: '#b5b9ba',
        greyDolphin: '#d2d5d6',
        greySeal: '#e5e5e5',
        greyMouse: '#eaeaea',
        greyErmine: '#f4f5f5',

        // Colours
        westblue: '#043de2',
        indigo: '#3c62c3',
        westblueTint: '#0a70f3',
        ladybird: '#ab2b2b',
        engineRed: '#C63400',
        cricketGreen: '#2c3e02',
        opinion: '#852BAB',
        java: '#13B4C3',
        persianGreen: '#02A2A3',
        teal: '#018384',
        hollywoodCerise: '#F400AB',
        electricViolet: '#AA01E1',
        breachNavy: '#001d56',

        // The Game Pick 11
        sunshineYellow: '#E4C300',
        canaryYellow: '#FFB506',
        fantaOrange: '#FF8900',

        // Regionals
        albanyadvertiserBlue: '#000099',
        augustamargaretrivertimesOrange: '#d3420d',
        broomeadvertiserGreen: '#00856f',
        bunburyheraldBlue: '#0071bb',
        busseltondunsboroughtimesTeal: '#0080a3',
        countrymanRed: '#e01f2e',
        geraldtonguardianRed: '#c4161c',
        greatsouthernheraldBlue: '#006ad3',
        harveywaroonareporterGreen: '#008542',
        kalgoorlieminerRed: '#e22822',
        manjimupbridgetowntimesBlue: '#2478cc',
        midwesttimesRed: '#e7131a',
        narroginobserverBlue: '#007bc7',
        northwesttelegraphOcre: '#cc4928',
        pilbaranewsOrange: '#cd470e',
        soundtelegraphBlue: '#007acc',
        southwesterntimesRed: '#da2128',
        thekimberleyechoRed: '#e7131a',
        //using gradients on the flat blue and flat black because hover transition between flat colors and a gradient cause a flash
        grandfinalBlue:
            'linear-gradient(179.74deg, #001F54 0.25%, #003897 116.15%)',
        grandfinalBlack:
            'linear-gradient(179.75deg, #011A45 0.24%, #012A71 116.16%)',
        freoGrandFinalPurple:
            'linear-gradient(129.35deg, #48008F 15.06%, #1A013A 87.96%)',
        freoGrandFinalPurpleBlack:
            'linear-gradient(0deg, rgba(0, 0, 0, 0.16), rgba(0, 0, 0, 0.16)), linear-gradient(129.35deg, #37016F 15.06%, #170232 87.96%)',
    },

    sevennews: {
        // Common colors
        red: '#E6001E',
        darkRed: '#b60920',
        redRedLowOpac: '#b6092033',
        stormGrey: '#737480',
        tundora: '#4d4d4d',
        charade: '#292A33',
        midGray: '#696A70',
        alto: '#dfdfdf',
        turbo: '#FBE400',
        greyMarble: '#ccc',
        /* #000 30% opacity */
        boxShadow: '#0000001f',
        /* background color */
        seashell: '#f1f1f1',
        trendingGrey: '#616161',

        // default
        /* Seven News blue */
        toreaBay: '#162EA6',
        resolutionBlue: '#002482',
        /* rollover colors */
        blueRibbon: '#2e49fe',
        gulfBlue: '#070966',
        chillBlue: '#8a97d2',
        plumFuzz: '#332D46',

        // sunrise
        piper: '#CF5226',
        piperDark: '#A5421E',
        blazeOrange: '#FF670A',
        chillOrange: '#e7a893',

        // The morning Show
        endeavour: '#0058AD',
        endeavourDark: '#003E79',
        azureRadiance: '#0777E5',
        chillEndeavour: '#80abd6',

        // Spotlight
        kashmirBlue: '#48639A',
        pickledBluewood: '#262F4B',
        pickledBluewoodDark: '#1B2135',
        chillPickledBluewood: '#9397a5',

        // Happening Now
        happeningBlue: '#0a3ac1',

        // Lifestyle
        lifestylePink: '#B04AE3',

        // Entertainment
        entertainmentPurple: '#A8328B',

        // Latest
        latestRed: '#FF0505',

        // Default theme
        defaultRed: '#BF001F',

        //SNEnt
        snentpurple: '#A583F1',

        flyoutLinkRed: '#B80018',
        flyoutLinkGrey: '#1F351B',

        bauhausBlack: '#333333',

        dustyGray: '#979797',

        breakingLive: '#9B0809',
        pulsingDot: '#FF0000',

        election: {
            colectionBg:
                'linear-gradient(176.31deg, #1F05E1 3.44%, #E6001E 51.78%, rgba(230, 0, 30, 0) 83.71%)',
        },
    },

    // Colour styleguide at https://projects.invisionapp.com/boards/GR3B3B7J79BFN/
    perthnow: {
        // Shades of grey
        greyCoal: '#252525',
        greyMoonstone: '#777',
        greyStone: '#999',
        greyMarble: '#ccc',
        greyPyrite: '#e5e5e5',
        greyGlass: '#f3f3f3',

        greyBasalt: '#1b262e',
        greyBasalt60: `rgba(27, 38, 46, .6)`,
        greyBasalt80: `rgba(27, 38, 46, .8)`,
        greyBasalt90: `rgba(27, 38, 46, .9)`,

        greySlate: '#32373b',
        greyFlint: '#3c525c',
        greyShale: '#8798a1',
        greyPebble: '#97a5ad',
        greyPumice: '#bdbde0',

        // Colours
        blueSapphire: '#0771be', // News
        blueKyanite: '#066cb6', // Hovers
        blueCerulean: '#009FDA', // Community News
        redRuby: '#d42626', //PerthNow Red
        orangeCitrine: '#c74705', // Sport
        purpleAmethyst: '#a762a6', // Entertainment
        tealTopaz: '#0b8478', // Business
        pinkThulite: '#dd1466', // Lifestyle and Default
        greenJade: '#418702', // Have you heard
        greenTourmaline: '#038674', // Promotional Cards
    },

    // 2020 Election
    election: {
        redBlueGradient:
            'linear-gradient(90.01deg, rgb(30, 4, 226) 0.01%, rgb(176, 61, 40) 99.72%)',
    },

    // 2017 The Game
    theGame: {
        blue: '#3a3afc',
        yellow: '#ffe800',
    },

    // Social Media - used in Social buttons in The West and Perth Now
    social: {
        facebook: '#1877f2',
        facebookMessengerBlue: '#0084ff',
        twitter: '#4099ff',
        whatsapp: '#25d366',
        email: '#066cb6',
        reddit: '#ff5700',
        clipboard: '#520e44',
        rss: '#f26522',
        instagram: '#EF0075',
        linkedIn: '#2f76af',
        youtube: '#ce1312',
    },

    sevennewsSocial: {
        twitter: '#55acee',
        email: '#162ea6',
        rss: '#f8991d',
        clipboard: '#5C5D66',
    },
}
